module.exports = __webpack_public_path__ + "static/media/transp.cd59adfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/transp.svg
// module id = 216
// module chunks = 0